@if (!hideHeader) {
  <app-header></app-header>
}
<router-outlet></router-outlet>
@if (!hideHeader) {
  <app-chatbot></app-chatbot>
}
